import createLucideIcon from '../createLucideIcon';

const Disc2 = createLucideIcon('Disc2', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '4', key: '4exip2' }],
  ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
]);

export default Disc2;
